const StuckCard = ({ tips }) => (
  <div
    data-testid="stuck-card"
    className="bg-white rounded-2xl border-l-4 border-brand-teal p-5 shadow-sm"
  >
    <p className="text-xs font-bold uppercase tracking-[0.12em] text-brand-teal mb-3">
      Stuck? Try this
    </p>
    <ul className="space-y-2.5">
      {tips.map((tip, i) => (
        <li key={i} className="flex items-start gap-2 text-sm text-ink-secondary leading-relaxed">
          <span className="text-brand-teal font-bold mt-px shrink-0">→</span>
          <span>{tip}</span>
        </li>
      ))}
    </ul>
  </div>
);

export default StuckCard;
